import React from 'react'
import VatSwitch from '../Plans/VatSwitch';
import Subscriber from "../../subscriber.class";
import Storage from "../../services/storage.service";

export default class VatWrapper extends Subscriber {
    componentDidMount() {
        this.subscriptions.push(
          Storage.get_obsrv("use_vat").subscribe((data) => {
            this.setState({
              use_vat: data,
            },()=>{
                if(this.props.callback){
                    this.props.callback(data);
                }
            });
          })
        );
    }

    render() {
        return(<VatSwitch/>);
    }
}